export const ACTIVE_AB_TESTS_PATH = '/__/active_abtests';
export const AB_TESTS_CONFIG_PATH = '/__/abtests_config';
